import * as React from "react";
import { cn } from "../lib/utils";

const Switch = React.forwardRef(({
  className,
  checked,
  defaultChecked = false,
  onCheckedChange,
  onChange,
  disabled,
  ...props
}, ref) => {
  const isControlled = checked !== undefined;
  const [internalChecked, setInternalChecked] = React.useState(defaultChecked);
  const isChecked = isControlled ? Boolean(checked) : internalChecked;

  const handleChange = (event) => {
    const nextChecked = event.target.checked;
    if (!isControlled) setInternalChecked(nextChecked);
    onCheckedChange?.(nextChecked);
    onChange?.(event);
  };

  return (
    <label data-slot="switch" className={cn("relative inline-flex cursor-pointer items-center", disabled && "cursor-not-allowed", className)}>
      <input
        type="checkbox"
        role="switch"
        checked={isChecked}
        disabled={disabled}
        aria-checked={isChecked}
        onChange={handleChange}
        className="peer sr-only"
        ref={ref}
        {...props}
      />
      <span aria-hidden className="relative h-[var(--ds-switch-height)] w-[var(--ds-switch-width)] rounded-full bg-input/70 ring-offset-background transition-colors peer-focus-visible:outline-none peer-focus-visible:ring-[var(--ds-focus-ring-width)] peer-focus-visible:ring-ring/40 peer-focus-visible:ring-offset-[var(--ds-focus-ring-offset)] peer-checked:bg-primary after:absolute after:left-[var(--ds-switch-inset)] after:top-[var(--ds-switch-inset)] after:size-[var(--ds-switch-thumb-size)] after:rounded-full after:border after:border-border after:bg-background after:shadow-[var(--shadow-control)] after:transition-transform peer-checked:after:translate-x-[var(--ds-switch-translate)] peer-checked:after:border-primary-foreground" />
    </label>
  );
});
Switch.displayName = "Switch";

export { Switch };
